import React, {useMemo} from 'react';
import {Tooltip} from 'primereact/tooltip';
import {
  AbbreviationMap,
  AbbreviationsProcessor,
  AbbreviationTooltip,
  ProcessedAbbreviationResult
} from '../utils/abbreviationProcessor';
import './DetailsDescriptionSection.scss';

interface DetailsDescriptionSectionProps {
  title: string;
  content: string;
  archiveAbbreviations?: AbbreviationMap;
  bibliographyAbbreviations?: AbbreviationMap;
  footnoteReferences?: AbbreviationMap;
}

const DetailsDescriptionSection: React.FC<DetailsDescriptionSectionProps> = ({
                                                                               title,
                                                                               content,
                                                                               archiveAbbreviations = {},
                                                                               bibliographyAbbreviations = {},
                                                                               footnoteReferences = {}
                                                                             }) => {
  const processedData: ProcessedAbbreviationResult = useMemo(() => {
    const processor = new AbbreviationsProcessor(content);
    processor.processAbbreviations(archiveAbbreviations, 'archive-abbr', true);
    processor.processAbbreviations(bibliographyAbbreviations, 'bibliography-abbr', false);
    processor.processAbbreviations(footnoteReferences, 'footnote-ref', false, false);
    processor.resolveTooltips();
    return processor.getResult();
  }, [content, archiveAbbreviations, bibliographyAbbreviations, footnoteReferences]);

  return (
    <section className="bg-white shadow-sm p-8">
      <h2 className="text-2xl font-bold text-stone-900 mb-6">{title}</h2>
      <div className="prose prose-stone max-w-none">
        <div
          className="text-stone-700 leading-relaxed whitespace-pre-wrap"
          dangerouslySetInnerHTML={{__html: processedData.content}}
        />
        {processedData.tooltips.map((tooltip: AbbreviationTooltip) => (
          <Tooltip
            key={tooltip.id}
            target={`#${tooltip.id}`}
            autoHide={false}
            pt={{
              text: {className: 'bg-gray-600 text-white'}
            }}
          >
            {tooltip.escape ? (
              <div className="max-w-md">{tooltip.content}</div>
            ) : (
              <div className="max-w-md" dangerouslySetInnerHTML={{__html: tooltip.content}}/>
            )}
          </Tooltip>
        ))}
      </div>
    </section>
  );
};

export default DetailsDescriptionSection;

